export enum VatModes {
    VAT_EXCL = 'VAT_EXCL',
    VAT_INCL = 'VAT_INCL'
}
